var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-select',{attrs:{"required":_vm.required,"error":_vm.error,"name":"active","labelClasses":_vm.labelClasses,"inputHolderClasses":_vm.inputHolderClasses,"label":"active","options":_vm.options,"value":_vm.internalValue},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }